/** @constant {String} - CSS class of the donation form element. */
const DONATION_FORM_CLASS = 'donation-form'
/** @constant {String} - Css id -> Needs the current amount for a successful payment. */
const ID_AMOUNT = 'id_amount'
/** @constant {String} - Css class for insert custom price. */
const CUSTOM_AMOUNT_CLASS = 'custom-amount'
/** @constant {String} - Css input submit. For adding amount on the input submit value. */
const SUBTMIT_BUTTON = 'input[type="submit"]'
/** @constant {String} - Css element with pre-filled amount. */
const AMOUNT_BOX_RADIOS = '.amount-box input[type="radio"]'
/** @constant {String} - Css element with pre-filled select currency. */
const SELECT_CURRENCY_RADIOS = 'select-currency input[type="radio"]'
/** @constant {String} - Css class for insert amount radio inputs*/
const AMOUNT_BOX_CLASS = 'amount-box'
/** @constant {String} - Css id -> Needs the current currency for a successful payment. */
const ID_CURRENCY = 'id_currency'
/** @constant {String} - Default currencies*/
const CZK_CURRENCY = 'CZK'
const EUR_CURRENCY = 'EUR'


/** Manages current value for ID_AMOUNT, SUBTMIT_BUTTON, CUSTOM_AMOUNT_CLASS */
export class AmountChooser {
    constructor(form, jsonData) {
        this.form = form
        this.amount = form.querySelector(`#${ID_AMOUNT}`)
        this.submit = form.querySelector(`${SUBTMIT_BUTTON}`)
        this.custom = form.querySelector(`.${CUSTOM_AMOUNT_CLASS}`)
        this.defaultSubmitValue = this.submit.value
        this.amount.parentElement.classList.add('hidden')
        this.jsonData = jsonData
        this.currencyRadios = form.querySelectorAll(`.${SELECT_CURRENCY_RADIOS}`)
        this.amountBox = form.querySelector(`.${AMOUNT_BOX_CLASS}`)
        this.idCurrency = form.querySelector(`#${ID_CURRENCY}`)
        this.idCurrency.parentElement.classList.add('hidden')
        this.dataCurrency = form.dataset.currency
        this._initCurrency()
        this.amountRadios = form.querySelectorAll(`${AMOUNT_BOX_RADIOS}`)
        this._initAmountRadios()
        this._initCustomInput()
        this._activate()

    }

    /**
     * Set and insert in the HTML DOM amounts for currency.
     * Default currency is select ID_CURRENCY
     *
     */
    _initCurrency() {
        // Default currency value, used for sutbmit button.
        this.dataCurrency === 'cs'
            ? (this.amountBoxDOM(CZK_CURRENCY), this.currency = CZK_CURRENCY)
            : (this.amountBoxDOM(EUR_CURRENCY), this.currency = EUR_CURRENCY)

        // Check currency radio.
        Array.from(this.currencyRadios).find((i) => i.value === this.currency).checked = true
        this.idCurrencyToggle()
        this.currencyToggle()
    }

    _activate() {
        if (this.amount.value) {
            const el = Array.from(this.amountRadios).find((i) => i.value === this.amount.value)
            if (el) {
                this.updateAmountChoice(el)
            } else {
                this.custom.value = this.amount.value
                this.activeCustomAmount()
                this.updateCustomAmount()
            }
        } else {
            const el = Array.from(this.amountRadios).find((i) => i.parentElement.classList.contains('choice-amount'))
            this.updateAmountChoice(el)
        }
    }

    /**
     * Listeners for events on CUSTOM_AMOUNT_CLASS.
     *
     */
    _initCustomInput() {
        this.custom.addEventListener('focus', () => this.activeCustomAmount())
        this.custom.addEventListener('keyup', () => this.updateCustomAmount())
        this.custom.addEventListener('change', () => this.updateCustomAmount())
    }

    /**
     * Listeners for events on amount input[type="radio"].
     *
     */
    _initAmountRadios() {
        for (const input_radio of this.amountRadios) {
            input_radio.addEventListener('click', () => this.updateAmountChoice(input_radio))
        }
    }

    /**
     * Listeners for events on currency input[type="radio"].
     *
     */
    currencyToggle() {
        for (const input_radio of this.currencyRadios) {
            input_radio.addEventListener('click', () => this.updateCurrencyChoice(input_radio))
        }
    }

    /**
     * According to the selected currency sets ID_CURRENCY, AMOUNT_BOX_CLASS
     *
     * @param {HTMLInputElement} input_radio
     */
    updateCurrencyChoice(input_radio) {
        this.currency = input_radio.value

        this.idCurrencyToggle()
        this.amountBox.textContent = ''
        this.amountBoxDOM(input_radio.value)
        this.amountRadios = this.form.querySelectorAll(`${AMOUNT_BOX_RADIOS}`)

        this._initAmountRadios()
        this._initCustomInput()
        this.setAmountFromRadio(this.amountBox.querySelector('div:nth-of-type(2) input'))

    }

    /**
     * New selected for ID_CURRENCY.
     *
     */
    idCurrencyToggle() {
        for (const option of this.idCurrency) {
            option.selected ? option.removeAttribute('selected') : null
            option.value === this.currency ? option.selected = true : null
        }
    }

    /**
     * Set donation amount from chosen radio input.
     *
     * @param {HTMLInputElement} input_radio
     */
    setAmountFromRadio(input_radio) {
        this.amount.value = input_radio.value
        this.submit.value = `${this.defaultSubmitValue} ${input_radio.value} ${this.currency}`
        this.custom.value = ''
    }

    /**
     * Switch a chosen radio input and update the donation amount to its value.
     *
     * @param {HTMLInputElement} input_radio
     */
    updateAmountChoice(input_radio) {
        this.submit.removeAttribute('disabled')
        for (const radio of this.amountRadios) {
            radio.parentElement.classList.remove('choice-amount')
        }
        input_radio.parentElement.classList.add('choice-amount')
        this.setAmountFromRadio(input_radio)
    }

    /**
     * Manage values for focus on CUSTOM_AMOUNT_CLASS.
     * Remove checked from input[type="radio"].
     *
     */
    activeCustomAmount() {
        for (const radio of this.amountRadios) {
            radio.parentElement.classList.remove('choice-amount')
        }
        this.submitToggle()
        this.amount.value = ''
        this.submit.value = `${this.defaultSubmitValue}`
    }

    /**
     * Update the donation amount from the custom value.
     */
    updateCustomAmount() {
        this.amount.value = this.custom.value
        this.custom.value.length > 0
            ? (this.submit.value = `${this.defaultSubmitValue} ${this.custom.value} ${this.currency}`)
            : (this.submit.value = `${this.defaultSubmitValue}`)
        this.submitToggle()
    }

    submitToggle() {
        this.custom.value.length > 0 ? this.submit.removeAttribute('disabled') : this.submit.disabled = 'true'
    }


    /**
     * Set amounts by ID_CURRENCY / SELECT_CURRENCY_RADIO.
     *
     * @param {HTMLInputElement} inputValue
     */
    amountBoxDOM(inputValue) {
        for (const [key, value] of Object.entries(this.jsonData)) {
            if (key === inputValue) {
                this.amountBox.insertAdjacentHTML('afterbegin', this.htmlAmount(key, value))
            }
        }
    }

    /**
     * Return HTML DOM (radio inputs) for selected currency.
     *
     */
    htmlAmount(key, value) {
        return `
            <div>
                <input type="radio" id="amount-${value[0]}" name="choice-amount" value="${value[0]}" />
                <label for="amount-${value[0]}">
                    <span>${value[0]} ${key}</span>
                </label>
            </div>
            <div class="choice-amount">
                <input type="radio" id="amount-${value[1]}" name="choice-amount" value="${value[1]}" />
                <label for="amount-${value[1]}">
                    <span>${value[1]} ${key}</span>
                </label>
            </div>
            <div>
                <input type="radio" id="amount-${value[2]}" name="choice-amount" value="${value[2]}" />
                <label for="amount-${value[2]}">
                    <span>${value[2]} ${key}</span>
                </label>
            </div>
        `
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const jsonData = JSON.parse(document.querySelector('#amounts-data').textContent)
    for (const form of document.querySelectorAll(`.${DONATION_FORM_CLASS}`)) {
        new AmountChooser(form, jsonData)
    }
})
